import { ProjectsList, ProjectsNavigation } from "@modules/home/components";

export function Projects() {
  return (
    <div className="overflow-y-hidden bg-white pt-16">
      <div className="container pe-0 relative max-lg:gap-6 grid lg:grid-cols-12 items-center gap-4">
        <ProjectsNavigation />
        <ProjectsList />
      </div>
    </div>
  );
}
